export default "__VITE_ASSET__1522e0dc__"